import { render, staticRenderFns } from "./AccidentNotifycation.vue?vue&type=template&id=0e8e11c7&scoped=true&"
import script from "./AccidentNotifycation.vue?vue&type=script&lang=js&"
export * from "./AccidentNotifycation.vue?vue&type=script&lang=js&"
import style0 from "./AccidentNotifycation.vue?vue&type=style&index=0&id=0e8e11c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8e11c7",
  null
  
)

export default component.exports